module.exports = __webpack_public_path__ + "img/panduan.3cc777c1.svg";